
import { Badge } from "@/components/ui/badge";
import { extractFacilities } from "@/utils/facilityUtils";

interface VacationBadgesProps {
  vacation: any;
}

export const VacationBadges = ({ vacation }: VacationBadgesProps) => {
  const facilities = vacation ? extractFacilities(vacation) : [];
  const maxFacilitiesToShow = 4;
  const facilitiesToShow = facilities.slice(0, maxFacilitiesToShow);
  const hasMoreFacilities = facilities.length > maxFacilitiesToShow;

  return (
    <div className="flex flex-wrap gap-1">
      {vacation.all_inclusive === 'Yes' && (
        <Badge variant="secondary">All Inclusive</Badge>
      )}
      {vacation.adults_only === 'Yes' && (
        <Badge variant="secondary">Adults Only</Badge>
      )}
      {vacation.childFriendly === 'Yes' && (
        <Badge variant="secondary">Kindvriendelijk</Badge>
      )}
      
      {facilitiesToShow.map((facility, index) => {
        const IconComponent = facility.icon;
        return (
          <Badge key={`facility-${index}-${facility.label}`} variant="secondary" className="flex items-center gap-1">
            <IconComponent className="h-3 w-3 flex-shrink-0" />
            <span>{facility.label}</span>
          </Badge>
        );
      })}
      
      {hasMoreFacilities && (
        <Badge variant="secondary" className="text-xs">
          +{facilities.length - maxFacilitiesToShow} meer
        </Badge>
      )}
    </div>
  );
};
